export default __webpack_public_path__ + "static/media/pdf.4b62b992.svg";